export function parseParams(textValue: string, paramObject: any) {
  return Object.keys(paramObject).reduce((text, key) => text.replace('${' + key + '}', paramObject[key]), textValue);
}
